import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ExtraServiceOrderType, ExtraServiceChekoutScreen } from 'constants/extra-service';
import { CreditCardAddReturnResult, CreditCardAddSourceEntityType } from 'constants/credit-card';
import { getClosestValue } from 'libs/utils/number';
import { removeParamsFromQuery, toParams } from 'libs/utils/url';
const SUPPORTED_SCREEN_DEPTHS = [1, 4, 8, 15, 16, 24, 32, 48];

const normalizeScreenColorDepth = colorDepth => {
  return getClosestValue(colorDepth, [...SUPPORTED_SCREEN_DEPTHS]);
};

export const getBrowserAttributes = () => {
  const {
    screen,
    navigator
  } = window;
  return {
    language: navigator.language,
    javaEnabled: navigator.javaEnabled(),
    colorDepth: normalizeScreenColorDepth(screen.colorDepth),
    screenWidth: screen.width,
    screenHeight: screen.height,
    timezoneOffset: new Date().getTimezoneOffset()
  };
};
export const isValidCreditCardAddReturnResult = value => {
  if (!value) return false;
  if (Array.isArray(value)) return false;
  return Object.values(CreditCardAddReturnResult).includes(value);
};

const parseCardAddResult = cardAddResult => {
  return isValidCreditCardAddReturnResult(cardAddResult) ? cardAddResult : undefined;
};

const parseCardId = card_id => {
  const cardId = Number(card_id);
  if (Number.isNaN(cardId)) return undefined;
  return "".concat(cardId);
};

const parseExtraServiceOrderId = (urlQuery, orderType) => {
  const {
    push_up_order_id,
    closet_promotion_order_id,
    direct_donation_order_id,
    featured_collection_order_id,
    return_label_order_id
  } = toParams(urlQuery);

  switch (orderType) {
    case ExtraServiceOrderType.PushUp:
      return push_up_order_id && Number(push_up_order_id);

    case ExtraServiceOrderType.ClosetPromotion:
      return closet_promotion_order_id && Number(closet_promotion_order_id);

    case ExtraServiceOrderType.DirectDonation:
      return direct_donation_order_id && Number(direct_donation_order_id);

    case ExtraServiceOrderType.FeaturedCollection:
      return featured_collection_order_id && Number(featured_collection_order_id);

    case ExtraServiceOrderType.ReturnLabel:
      return return_label_order_id && Number(return_label_order_id);

    default:
      return undefined;
  }
};

export const parseCardAddRedirectUrl = urlQuery => {
  const {
    card_add_result,
    external_card_code
  } = toParams(urlQuery);
  return {
    cardId: parseCardId(external_card_code),
    cardAddResult: parseCardAddResult(card_add_result)
  };
};
export const parseEscrowPaymentRedirectUrl = urlQuery => {
  const {
    after_payment_redirect
  } = toParams(urlQuery);
  return {
    isRedirectAfterPayment: !Array.isArray(after_payment_redirect) && (after_payment_redirect === null || after_payment_redirect === void 0 ? void 0 : after_payment_redirect.toLowerCase()) === 'true'
  };
};
export const parseExtraServiceCardAddRedirectUrl = (urlQuery, orderType) => {
  const commonCreditCardAddParams = parseCardAddRedirectUrl(urlQuery);
  return _objectSpread(_objectSpread({}, commonCreditCardAddParams), {}, {
    orderId: parseExtraServiceOrderId(urlQuery, orderType)
  });
};

const getPushUpCreditCardSource = _ref => {
  let {
    page,
    itemId,
    userId
  } = _ref;

  switch (page) {
    case ExtraServiceChekoutScreen.MultiplePushUp:
      return {
        entityType: CreditCardAddSourceEntityType.NewPushUpOrder
      };

    case ExtraServiceChekoutScreen.Item:
      return {
        entityId: itemId,
        entityType: CreditCardAddSourceEntityType.ItemPushUpOrder
      };

    case ExtraServiceChekoutScreen.UserProfile:
      return {
        entityId: userId,
        entityType: CreditCardAddSourceEntityType.ProfilePushUpOrder
      };

    default:
      return {
        entityType: CreditCardAddSourceEntityType.Unknown
      };
  }
};

const getClosetPromotionCreditCardSource = _ref2 => {
  let {
    page,
    userId
  } = _ref2;

  switch (page) {
    case ExtraServiceChekoutScreen.Catalog:
    case ExtraServiceChekoutScreen.NewsFeed:
      return {
        entityType: CreditCardAddSourceEntityType.MainClosetPromotion
      };

    case ExtraServiceChekoutScreen.UserProfile:
      return {
        entityId: userId,
        entityType: CreditCardAddSourceEntityType.ProfileClosetPromotion
      };

    default:
      return {
        entityType: CreditCardAddSourceEntityType.Unknown
      };
  }
};

const getDirectDonationCreditCardSource = _ref3 => {
  let {
    page
  } = _ref3;

  switch (page) {
    case ExtraServiceChekoutScreen.Balance:
      return {
        entityType: CreditCardAddSourceEntityType.DirectDonationOrder
      };

    case ExtraServiceChekoutScreen.Donate:
      return {
        entityType: CreditCardAddSourceEntityType.WebviewDirectDonationOrder
      };

    default:
      return {
        entityType: CreditCardAddSourceEntityType.Unknown
      };
  }
};

const getFeaturedCollectionCreditCardSource = _ref4 => {
  let {
    page,
    featuredCollectionId
  } = _ref4;

  switch (page) {
    case ExtraServiceChekoutScreen.FeaturedCollection:
      return {
        entityId: featuredCollectionId,
        entityType: CreditCardAddSourceEntityType.FeaturedCollection
      };

    default:
      return {
        entityType: CreditCardAddSourceEntityType.Unknown
      };
  }
};

const getReturnShipmentCreditCardSource = _ref5 => {
  let {
    page,
    conversationId,
    complaintId
  } = _ref5;

  switch (page) {
    case ExtraServiceChekoutScreen.MessageList:
      return {
        entityId: conversationId,
        entityType: CreditCardAddSourceEntityType.MsgThreadReturnLabelOrder
      };

    case ExtraServiceChekoutScreen.ViewIssueDetails:
      return {
        entityId: complaintId,
        entityType: CreditCardAddSourceEntityType.ComplaintReturnLabelOrder
      };

    default:
      return {
        entityType: CreditCardAddSourceEntityType.Unknown
      };
  }
};

export const getCreditAddCardSource = sourceParams => {
  switch (sourceParams.type) {
    case 'escrow':
      return {
        entityId: sourceParams.transactionId,
        entityType: CreditCardAddSourceEntityType.Transaction
      };

    case 'settings':
      return {
        entityType: CreditCardAddSourceEntityType.PaymentSettings
      };

    case ExtraServiceOrderType.PushUp:
      return _objectSpread({
        orderId: sourceParams.orderId
      }, getPushUpCreditCardSource(sourceParams));

    case ExtraServiceOrderType.ClosetPromotion:
      return _objectSpread({
        orderId: sourceParams.orderId
      }, getClosetPromotionCreditCardSource(sourceParams));

    case ExtraServiceOrderType.DirectDonation:
      return _objectSpread({
        orderId: sourceParams.orderId
      }, getDirectDonationCreditCardSource(sourceParams));

    case ExtraServiceOrderType.FeaturedCollection:
      return _objectSpread({
        orderId: sourceParams.orderId
      }, getFeaturedCollectionCreditCardSource(sourceParams));

    case ExtraServiceOrderType.ReturnLabel:
      return _objectSpread({
        orderId: sourceParams.orderId
      }, getReturnShipmentCreditCardSource(sourceParams));

    default:
      return {
        entityType: CreditCardAddSourceEntityType.Unknown
      };
  }
};
export const removeRedirectUrlParams = (relativeUrl, urlQuery) => removeParamsFromQuery(relativeUrl, urlQuery, ['card_id', 'card_add_result', 'push_up_order_id', 'external_card_code', 'closet_promotion_order_id', 'direct_donation_order_id', 'featured_collection_order_id', 'return_shipment_order_id']);